<template>
  <RecordViewWrapper>
    <sdPageHeader title="Periode Pengajuan PeG">
      <template #subTitle>
        <sdButton class="btn-add_new" size="default" type="primary">
          <router-link to="/assessment/master/periode-add">
            <sdFeatherIcons type="plus" size="14" /> Tambah</router-link
          >
        </sdButton>
      </template>
      <template #buttons>
        <div class="search-box">
          <span class="search-icon">
            <sdFeatherIcons type="search" size="14" />
          </span>
          <a-input
            @change="handleSearch"
            v-model:value.trim="formState.searchItem"
            type="text"
            name="recored-search"
            placeholder="Search Here"
          /></div
      ></template>
    </sdPageHeader>

    <Main>
      <a-row :gutter="15">
        <a-col class="w-100" :md="24">
          <sdCards headless>
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>

            <div v-else>
              <TableWrapper class="table-data-view table-responsive">
                <a-table
                  :pagination="{ pageSize: 10, showSizeChanger: true }"
                  :dataSource="dataSource"
                  :columns="columns"
                />
              </TableWrapper>
            </div>
          </sdCards>
        </a-col>
      </a-row>
    </Main>
  </RecordViewWrapper>
</template>

<script>
import { RecordViewWrapper } from '../../../../components/crud/style';
import { computed, onMounted, reactive } from 'vue';
import { Main, TableWrapper } from '../../../styled';
import { useStore } from 'vuex';
import { Modal } from 'ant-design-vue';

const columns = [
  {
    title: 'Nama',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Periode Pengajuan',
    dataIndex: 'periode_pengajuan',
    key: 'periode_pengajuan',
  },
  {
    title: 'Periode Approval',
    dataIndex: 'periode_approval',
    key: 'periode_approval',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    key: 'action',
    width: '90px',
  },
];

const ViewPage = {
  name: 'ViewPage',
  components: { RecordViewWrapper, Main, TableWrapper },
  setup() {
    const { state, dispatch } = useStore();
    const crud = computed(() => state.crud.data);
    const isLoading = computed(() => state.crud.loading);

    const formatDate = dateString => {
      if (!dateString) return '';
      const date = new Date(dateString);
      const months = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
      ];
      return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    };

    const getStatusColor = status => {
      return status === 'Active' ? 'green' : 'orange';
    };

    onMounted(() => {
      dispatch('axiosCrudGetData', 'periode-assessment');
    });

    const handleDelete = (id, name) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus periode ${name}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataDelete', {
            id,
            url: 'periode-assessment',
            getData: () => {
              dispatch('axiosCrudGetData', 'periode-assessment');
            },
          });
        },
      });
    };

    const formState = reactive({
      searchItem: '',
    });

    const dataSource = computed(() =>
      crud.value.length
        ? crud.value.map((data, key) => {
            const {
              id,
              nama_periode,
              tanggal_mulai_pengajuan,
              tanggal_selesai_pengajuan,
              tanggal_mulai_approval,
              tanggal_selesai_approval,
              is_active,
            } = data;

            const status = is_active ? 'Active' : 'Inactive';
            const statusColor = getStatusColor(status);

            return {
              key: key + 1,
              name: nama_periode,
              periode_pengajuan: `${formatDate(tanggal_mulai_pengajuan)} - ${formatDate(tanggal_selesai_pengajuan)}`,
              periode_approval: `${formatDate(tanggal_mulai_approval)} - ${formatDate(tanggal_selesai_approval)}`,
              status: <a-tag color={statusColor}>{status}</a-tag>,
              action: (
                <div class="table-actions">
                  <router-link class="delete" to={`/assessment/master/periode-edit/${id}`}>
                    <sdFeatherIcons type="edit" size={14} title="Ubah" />
                  </router-link>
                  &nbsp;&nbsp;&nbsp;
                  <router-link class="delete" onClick={() => handleDelete(id, data.nama_periode)} to="#">
                    <sdFeatherIcons type="trash-2" size={14} title="Hapus" />
                  </router-link>
                </div>
              ),
            };
          })
        : [],
    );

    const handleSearch = () => {
      dispatch('axiosDataSearch', { url: 'periode-assessment', filter: formState.searchItem });
    };

    return {
      formState,
      columns,
      isLoading,
      crud,
      dataSource,
      handleSearch,
    };
  },
};

export default ViewPage;
</script>
